import { forwardRef, InputHTMLAttributes, ReactNode } from "react"

import { cn } from "@/utils/tailwind"

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string
  rightContent?: ReactNode
  leftContent?: ReactNode
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, wrapperClassName, rightContent, leftContent, type, ...props }, ref) => {
    return (
      <div className={cn("relative h-9 w-full", wrapperClassName)}>
        <input
          type={type}
          className={cn(
            "focus-visible:ring-instacover-400 flex size-full rounded-md border border-slate-200 bg-white py-1 pl-3 text-sm text-slate-700 shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-400 focus-visible:ring-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
            rightContent ? "pr-10" : "pr-3",
            leftContent ? "pl-10" : "pl-3",
            className,
          )}
          ref={ref}
          {...props}
        />

        {rightContent && (
          <div className="absolute inset-y-0 right-0 flex w-10 items-center justify-center">{rightContent}</div>
        )}

        {leftContent && (
          <div className="absolute inset-y-0 left-0 flex w-10 items-center justify-center">{leftContent}</div>
        )}
      </div>
    )
  },
)

Input.displayName = "Input"

export { Input }
